import React, { useState, useEffect } from 'react';
import {
  Backdrop,
  CircularProgress,
  FormControl,
  Typography,
  IconButton,
  InputAdornment,
  Stack,
  Grid,
} from '@mui/material';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Switch from '@mui/material/Switch';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import api from 'src/services/BaseService';
import { useLocalization } from 'src/context/LocalizationContext';
import Iconify from '../iconify';

const AddStoreModal = ({ open, onClose, isEdit, editData, mallList }) => {
  const { language } = useLocalization();

  const [showResultMessage, setShowResultMessage] = useState(false);
  const [resultMessage, setResultMessage] = useState('');
  const [isBackdropOpen, setIsBackdropOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedOption, setSelectedOption] = useState('new');
  const [userList, setUserList] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');

  const [locationName, setLocationName] = useState('');
  const [locationAddress, setLocationAddress] = useState('');
  const [locationType, setLocationType] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const [name, setName] = useState('');
  const [lastname, setLastname] = useState('');
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');

  const [formData, setFormData] = useState({
    mallID: '',
    title: '',
    companyLegalTitle: '',
    companyCorporationalCode: '',
    taxNo: '',
    taxAdministration: '',
    address: '',
    city: '',
    region: '',
    country: 'Türkiye',
    isPrimary: false,
    // isHandsfree: false
  });

  const typeList = [
    { name: 'Mağaza', value: 'store' },
    { name: 'Depo', value: 'warehouse' },
  ];

  const cityList = [
    { id: 1, name: language.commons.cities.adana },
    { id: 2, name: language.commons.cities.adıyaman },
    { id: 3, name: language.commons.cities.afyonkarahisar },
    { id: 4, name: language.commons.cities.ağrı },
    { id: 5, name: language.commons.cities.amasya },
    { id: 6, name: language.commons.cities.ankara },
    { id: 7, name: language.commons.cities.antalya },
    { id: 8, name: language.commons.cities.artvin },
    { id: 9, name: language.commons.cities.aydın },
    { id: 10, name: language.commons.cities.balıkesir },
    { id: 11, name: language.commons.cities.bilecik },
    { id: 12, name: language.commons.cities.bingöl },
    { id: 13, name: language.commons.cities.bitlis },
    { id: 14, name: language.commons.cities.bolu },
    { id: 15, name: language.commons.cities.burdur },
    { id: 16, name: language.commons.cities.bursa },
    { id: 17, name: language.commons.cities.çanakkale },
    { id: 18, name: language.commons.cities.çankırı },
    { id: 19, name: language.commons.cities.çorum },
    { id: 20, name: language.commons.cities.denizli },
    { id: 21, name: language.commons.cities.diyarbakır },
    { id: 22, name: language.commons.cities.edirne },
    { id: 23, name: language.commons.cities.elazığ },
    { id: 24, name: language.commons.cities.erzincan },
    { id: 25, name: language.commons.cities.erzurum },
    { id: 26, name: language.commons.cities.eskişehir },
    { id: 27, name: language.commons.cities.gaziantep },
    { id: 28, name: language.commons.cities.giresun },
    { id: 29, name: language.commons.cities.gümüşhane },
    { id: 30, name: language.commons.cities.hakkari },
    { id: 31, name: language.commons.cities.hatay },
    { id: 32, name: language.commons.cities.ısparta },
    { id: 33, name: language.commons.cities.mersin },
    { id: 34, name: language.commons.cities.istanbul },
    { id: 35, name: language.commons.cities.izmir },
    { id: 36, name: language.commons.cities.kars },
    { id: 37, name: language.commons.cities.kastamonu },
    { id: 38, name: language.commons.cities.kayseri },
    { id: 39, name: language.commons.cities.kırklareli },
    { id: 40, name: language.commons.cities.kırşehir },
    { id: 41, name: language.commons.cities.kocaeli },
    { id: 42, name: language.commons.cities.konya },
    { id: 43, name: language.commons.cities.kütahya },
    { id: 44, name: language.commons.cities.malatya },
    { id: 45, name: language.commons.cities.manisa },
    { id: 46, name: language.commons.cities.kahramanmaraş },
    { id: 47, name: language.commons.cities.mardin },
    { id: 48, name: language.commons.cities.muğla },
    { id: 49, name: language.commons.cities.muş },
    { id: 50, name: language.commons.cities.nevşehir },
    { id: 51, name: language.commons.cities.niğde },
    { id: 52, name: language.commons.cities.ordu },
    { id: 53, name: language.commons.cities.rize },
    { id: 54, name: language.commons.cities.sakarya },
    { id: 55, name: language.commons.cities.samsun },
    { id: 56, name: language.commons.cities.siirt },
    { id: 57, name: language.commons.cities.sinop },
    { id: 58, name: language.commons.cities.sivas },
    { id: 59, name: language.commons.cities.tekirdağ },
    { id: 60, name: language.commons.cities.tokat },
    { id: 61, name: language.commons.cities.trabzon },
    { id: 62, name: language.commons.cities.tunceli },
    { id: 63, name: language.commons.cities.şanlıurfa },
    { id: 64, name: language.commons.cities.uşak },
    { id: 65, name: language.commons.cities.van },
    { id: 66, name: language.commons.cities.yozgat },
    { id: 67, name: language.commons.cities.zonguldak },
    { id: 68, name: language.commons.cities.aksaray },
    { id: 69, name: language.commons.cities.bayburt },
    { id: 70, name: language.commons.cities.karaman },
    { id: 71, name: language.commons.cities.kırıkkale },
    { id: 72, name: language.commons.cities.batman },
    { id: 73, name: language.commons.cities.şırnak },
    { id: 74, name: language.commons.cities.bartın },
    { id: 75, name: language.commons.cities.ardahan },
    { id: 76, name: language.commons.cities.ığdır },
    { id: 77, name: language.commons.cities.yalova },
    { id: 78, name: language.commons.cities.karabük },
    { id: 79, name: language.commons.cities.kilis },
    { id: 80, name: language.commons.cities.osmaniye },
    { id: 81, name: language.commons.cities.düzce },
  ];

  const steps = [
    language.components.AddStoreModal.store_info,
    language.components.AddStoreModal.location_info,
    language.components.AddStoreModal.user_info,
  ];

  const handleTabChange = (event, newValue) => {
    setSelectedOption(newValue);
    setName('');
    setLastname('');
    setUserName('');
    setEmail('');
    setPhone('');
    setPassword('');
    setSelectedUser('');
  };

  const nextStep = () => {
    if (activeStep !== 2) {
      setActiveStep(activeStep + 1);
    }
  };

  const backStep = () => {
    if (activeStep !== 0) {
      setActiveStep(activeStep - 1);
    }
  };

  const updateUser = (branchID, selectedUser) => {
    const branchIDs = selectedUser.authLocations.branch.map(
      (item) => item.branchID
    );
    branchIDs.push(branchID);
    api
      .post('/users/update-profile', {
        userID: selectedUser.id,
        frontAuth: ['operations', 'manager'],
        isAdministrator: '1',
        authLocations: {
          branch: branchIDs,
        },
      })
      .then((response) => {
        if (response.data.status) {
          setResultMessage('Mağaza başarıyla eklendi!');
          setShowResultMessage(true);
          setIsBackdropOpen(false);
        } else {
          setResultMessage('Mağaza eklenirken bir sorunla karşılaşıldı!');
          setShowResultMessage(true);
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });
  };

  const createUser = (branchID) => {
    if (selectedOption === 'new') {
      api
        .post('/flow/user-create', {
          mallID: formData.mallID,
          corporationID: '',
          branchID: branchID,
          email: email,
          phone: phone,
          name: name,
          lastname: lastname,
          password: password,
          username: userName,
          type: 'corporational',
          isAdministrator: true,
          accountCategory: 'store',
          frontAuth: ['operations', 'manager'],
          authLocations: {
            branch: [branchID],
            mallID: [formData.mallID],
          },
        })
        .then((response) => {
          if (response.data.status) {
            createLocation(branchID, response.data.result);
          } else {
            setResultMessage('Mağaza eklenirken bir sorunla karşılaşıldı!');
            setShowResultMessage(true);
          }
        });
    }
  };

  const createLocation = (branchID, selectedUser) => {
    if (selectedOption === 'new') {
      api
        .post('/flow/location-create', {
          title: locationName,
          mallID: formData.mallID,
          corporationID: '',
          branchID: branchID,
          type: locationType,
          adminUserID: selectedUser,
          address: locationAddress,
        })
        .then((response) => {
          if (response.data.status) {
            setResultMessage('Mağaza başarıyla eklendi!');
            setShowResultMessage(true);
            setIsBackdropOpen(false);
          } else {
            setResultMessage('Mağaza eklenirken bir sorunla karşılaşıldı!');
            setShowResultMessage(true);
          }
        });
    } else if (selectedOption === 'existing') {
      api
        .post('/flow/location-create', {
          title: locationName,
          mallID: formData.mallID,
          corporationID: '',
          branchID: branchID,
          type: locationType,
          adminUserID: selectedUser.id,
          address: locationAddress,
        })
        .then((response) => {
          if (response.data.status) {
            updateUser(branchID, selectedUser);
            setResultMessage('Mağaza başarıyla eklendi!');
          } else {
            setResultMessage('Mağaza eklenirken bir sorunla karşılaşıldı!');
            setShowResultMessage(true);
          }
        });
    } else if (selectedOption === 'proceed') {
      api
        .post('/flow/location-create', {
          title: locationName,
          mallID: formData.mallID,
          corporationID: '',
          branchID: branchID,
          type: locationType,
          adminUserID: '',
          address: locationAddress,
        })
        .then((response) => {
          if (response.data.status) {
            setResultMessage('Mağaza başarıyla eklendi!');
            setShowResultMessage(true);
            setIsBackdropOpen(false);
          } else {
            setResultMessage('Mağaza eklenirken bir sorunla karşılaşıldı!');
            setShowResultMessage(true);
          }
        });
    }
  };

  const handleSave = () => {
    setIsBackdropOpen(true);
    let isPrimaryBoolean;
    if (formData.isPrimary === false) {
      isPrimaryBoolean = '0';
    } else {
      isPrimaryBoolean = '1';
    }
    if (selectedOption === 'new') {
      api
        .post('/flow/branch-create', {
          title: formData.title,
          mallID: formData.mallID,
          corporationID: '',
          type: 'corporational',
          companyLegalTitle: formData.companyLegalTitle,
          billing: {
            status: true,
            type: 'corporational',
            taxNo: formData.taxNo,
            taxAdministration: formData.taxAdministration,
            address: formData.address,
            region: formData.region,
            city: formData.city,
            country: formData.country,
          },
          companyCorporationalCode: formData.companyCorporationalCode,
          isPrimary: isPrimaryBoolean,
          // isHandsfree: formData.isHandsfree
        })
        .then((response) => {
          if (response.data.status) {
            // console.log(response.data, "Add Branch Result")
            createUser(response.data.result);
          } else {
            setResultMessage('Mağaza eklenirken bir sorunla karşılaşıldı!');
            setShowResultMessage(true);
            // toast.error(response.data.message);
          }
        })
        .catch((error) => {
          // console.log(error);
          // toast.error(error.message);
        });
    } else if (selectedOption === 'existing') {
      api
        .post('/flow/branch-create', {
          title: formData.title,
          mallID: formData.mallID,
          corporationID: '',
          type: 'corporational',
          companyLegalTitle: formData.companyLegalTitle,
          billing: {
            status: true,
            type: 'corporational',
            taxNo: formData.taxNo,
            taxAdministration: formData.taxAdministration,
            address: formData.address,
            region: formData.region,
            city: formData.city,
            country: formData.country,
          },
          companyCorporationalCode: formData.companyCorporationalCode,
          isPrimary: isPrimaryBoolean,
          // isHandsfree: formData.isHandsfree
        })
        .then((response) => {
          if (response.data.status) {
            createLocation(response.data.result, selectedUser);
          } else {
            setResultMessage('Mağaza eklenirken bir sorunla karşılaşıldı!');
            setShowResultMessage(true);
          }
        });
    } else if (selectedOption === 'proceed') {
      api
        .post('/flow/branch-create', {
          title: formData.title,
          mallID: formData.mallID,
          corporationID: '',
          type: 'corporational',
          companyLegalTitle: formData.companyLegalTitle,
          billing: {
            status: true,
            type: 'corporational',
            taxNo: formData.taxNo,
            taxAdministration: formData.taxAdministration,
            address: formData.address,
            region: formData.region,
            city: formData.city,
            country: formData.country,
          },
          companyCorporationalCode: formData.companyCorporationalCode,
          isPrimary: isPrimaryBoolean,
          // isHandsfree: formData.isHandsfree
        })
        .then((response) => {
          if (response.data.status) {
            createLocation(response.data.result, '');
          } else {
            setResultMessage('Mağaza eklenirken bir sorunla karşılaşıldı!');
            setShowResultMessage(true);
          }
        });
    }
  };

  const allFieldsAreValid = () => {
    if (activeStep === 0) {
      if (
        formData.title !== '' &&
        formData.companyLegalTitle !== '' &&
        formData.taxNo !== ''
      ) {
        return true;
      } else return false;
    } else if (activeStep === 1) {
      if (
        formData.mallID !== '' &&
        locationName !== '' &&
        locationType !== ''
      ) {
        return true;
      } else return false;
    } else if (activeStep === 2 && selectedOption === 'proceed') {
      return true;
    } else if (activeStep === 2 && selectedOption === 'new') {
      if (
        name !== '' &&
        lastname !== '' &&
        userName !== '' &&
        email !== '' &&
        phone !== '' &&
        password !== ''
      ) {
        return true;
      } else return false;
    } else if (activeStep === 2 && selectedOption === 'existing') {
      if (
        name !== '' &&
        lastname !== '' &&
        userName !== '' &&
        email !== '' &&
        phone !== ''
      ) {
        return true;
      } else return false;
    }
  };

  const handleMallChange = async (event) => {
    const { value } = event.target;
    getUserList(value);
    setFormData((prevState) => ({
      ...prevState,
      mallID: value,
    }));
  };

  const handleCityChange = (event) => {
    const { value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      city: value,
    }));
  };

  const handleSwitchChange = () => {
    const { name, value } = event.target;
    if (name === 'isPrimary') {
      setFormData((prevState) => ({
        ...prevState,
        [name]: !formData.isPrimary, // Değerin tersine çevrilmesi
      }));
    }
    // else if (name === 'isHandsfree') {
    //   setFormData((prevState) => ({
    //     ...prevState,
    //     [name]: !formData.isHandsfree, // Değerin tersine çevrilmesi
    //   }));
    // }
    else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleTextFieldChange = (e) => {
    const { name, value } = e.target;
    if (name === 'taxNo') {
      if (/^\d*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (name === 'companyCorporationalCode') {
      if (/^[0-9.,]*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleClose = () => {
    setFormData({});
    onClose();
  };

  const handleCloseMessage = () => {
    setShowResultMessage(false);
    setFormData({});
    onClose();
  };

  const handleChangeSelectedUser = (e) => {
    const { value } = e.target;
    setSelectedUser(value);
    setName(value.name);
    setLastname(value.lastname);
    setUserName(value.username);
    setEmail(value.email);
    setPhone(value.phone);
  };

  const getUserList = (mallID) => {
    api
      .post('users/get-users', {
        type: 'corporational',
        mallID: mallID,
        status: '1',
      })
      .then((response) => {
        if (response.data.status) {
          setUserList(response.data.result);
        }
      });
  };

  useEffect(() => {
    if (isEdit) {
      console.log(editData);
      let isPrimaryBoolean;
      if (editData.isPrimary === '1') {
        isPrimaryBoolean = true;
      } else {
        isPrimaryBoolean = false;
      }
      setLocationAddress(editData.locationAddress);
      setLocationName(editData.locations[0].title);
      getUserList(editData.mallID);
      setFormData({
        mallID: editData.mallID,
        title: editData.title,
        companyLegalTitle: editData.companyLegalTitle,
        companyCorporationalCode: editData.companyCorporationalCode,
        taxNo: editData.billing?.taxNo,
        taxAdministration: editData.billing?.taxAdministration,
        address: editData.billing?.address,
        city: editData.billing?.city,
        region: editData.billing?.region,
        country: editData.billing?.country,
        isPrimary: isPrimaryBoolean,
      });
    }
  }, []);

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <Backdrop sx={{ color: '#fff', zIndex: 2 }} open={isBackdropOpen}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <Stack
          width="95%"
          direction="column"
          alignItems="flex-end"
          justifyContent="flex-end"
          marginTop={3}
          mb={5}
        >
          <div
            style={{
              flexDirection: 'row',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              marginTop: 10,
            }}
          >
            <Typography>
              {language.components.AddStoreModal.priority_store}
            </Typography>
            <Switch
              checked={formData.isPrimary}
              onChange={handleSwitchChange}
              name="isPrimary"
              color="primary"
              inputProps={{ 'aria-label': 'primary checkbox' }}
            />
          </div>
        </Stack>
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            {language.components.AddStoreModal.store_form}
          </Typography>
          <Typography gutterBottom>
            {language.components.AddStoreModal.list_warning}
          </Typography>
        </Stack>

        <Box sx={{ width: '100%' }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        {activeStep === 0 && (
          <DialogContent>
            <>
              <Grid xs={16} container alignItems="center" spacing={2}>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label={language.commons.column.store_name + '*'}
                    name="title"
                    value={formData.title}
                    onChange={handleTextFieldChange}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label={language.commons.column.commerce_name + '*'}
                    name="companyLegalTitle"
                    value={formData.companyLegalTitle}
                    onChange={handleTextFieldChange}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label={language.commons.column.current_code}
                    name="companyCorporationalCode"
                    value={formData.companyCorporationalCode}
                    onChange={handleTextFieldChange}
                    margin="normal"
                  />
                </Grid>
              </Grid>

              <Grid xs={16} container alignItems="center" spacing={2}>
                <Grid item xs={4}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>{language.commons.city}</InputLabel>
                    <Select
                      sx={{ width: '100%' }}
                      label={language.commons.city}
                      value={formData.city}
                      onChange={handleCityChange}
                      name="city"
                    >
                      {cityList.map((city, index) => (
                        <MenuItem key={index} value={city.name}>
                          {city.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label={language.commons.state}
                    name="region"
                    value={formData.region}
                    onChange={handleTextFieldChange}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label={language.commons.country}
                    name="Country"
                    value={formData.country}
                    onChange={handleTextFieldChange}
                    margin="normal"
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid xs={16} container alignItems="center" spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label={language.commons.labels.tax_office}
                    name="taxAdministration"
                    value={formData.taxAdministration}
                    onChange={handleTextFieldChange}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label={language.commons.labels.tax_no + '*'}
                    type="text"
                    name="taxNo"
                    value={formData.taxNo}
                    onChange={handleTextFieldChange}
                    margin="normal"
                  />
                </Grid>
              </Grid>

              <Grid xs={16} container alignItems="center" spacing={2}>
                <Grid item xs={16}>
                  <TextField
                    fullWidth
                    label={language.commons.labels.bill_adress}
                    name="address"
                    value={formData.address}
                    onChange={handleTextFieldChange}
                    margin="normal"
                  />
                </Grid>
              </Grid>

              <Grid xs={16} container alignItems="center" spacing={2}>
                <Grid item xs={16}>
                  <div
                    style={{
                      height: '1px',
                      backgroundColor: '#EAECF0',
                      margin: '0 15px',
                      marginTop: '32px',
                    }}
                  ></div>
                </Grid>
              </Grid>
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="space-between"
                mb={5}
              >
                <Button
                  color="primary"
                  onClick={nextStep}
                  variant="contained"
                  sx={{
                    marginTop: '32px',
                    width: '241px',
                    height: '46px',
                    backgroundColor: '#1570EF',
                    fontSize: 12,
                    fontWeight: 500,
                  }}
                  disabled={!allFieldsAreValid()}
                >
                  {language.commons.next_step}
                </Button>
              </Stack>
            </>
          </DialogContent>
        )}

        {activeStep === 1 && (
          <DialogContent>
            <>
              <Grid xs={16} container alignItems="center" spacing={2}>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>
                      {language.commons.labels.location_mall}*
                    </InputLabel>
                    <Select
                      label={language.commons.labels.location_mall + '*'}
                      value={formData.mallID}
                      onChange={handleMallChange}
                      name="mallID"
                      disabled={mallList.length === 0}
                    >
                      {mallList.map((mall, index) => (
                        <MenuItem key={index} value={mall.id}>
                          {mall.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label={language.commons.labels.location_name + '*'}
                    name="locationName"
                    value={locationName}
                    onChange={(e) => setLocationName(e.target.value)}
                    margin="normal"
                  />
                </Grid>
              </Grid>

              <Grid xs={16} container alignItems="center" spacing={2}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label={language.commons.labels.adress}
                    name="locationAddress"
                    value={locationAddress}
                    onChange={(e) => setLocationAddress(e.target.value)}
                    margin="normal"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>
                      {language.commons.labels.location_type}*
                    </InputLabel>
                    <Select
                      sx={{ width: '100%' }}
                      label="Lokasyon Türü*"
                      value={locationType}
                      onChange={(e) => setLocationType(e.target.value)}
                      name="locationType"
                    >
                      {typeList.map((type, index) => (
                        <MenuItem key={index} value={type.value}>
                          {type.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </>
            <Grid xs={16} container alignItems="center" spacing={2}>
              <Grid item xs={16}>
                <div
                  style={{
                    height: '1px',
                    backgroundColor: '#EAECF0',
                    margin: '0 15px',
                    marginTop: '32px',
                  }}
                ></div>
              </Grid>
            </Grid>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              mb={5}
            >
              <Button
                color="primary"
                onClick={backStep}
                variant="outlined"
                sx={{
                  marginTop: '32px',
                  width: '241px',
                  height: '46px',
                  marginRight: '25px',
                  fontSize: 12,
                  fontWeight: 500,
                }}
              >
                {language.commons.prev_step}
              </Button>
              <Button
                color="primary"
                onClick={nextStep}
                variant="contained"
                sx={{
                  marginTop: '32px',
                  width: '241px',
                  height: '46px',
                  backgroundColor: '#1570EF',
                  fontSize: 12,
                  fontWeight: 500,
                }}
                disabled={!allFieldsAreValid()}
              >
                {language.commons.next_step}
              </Button>
            </Stack>
          </DialogContent>
        )}

        {activeStep === 2 && (
          <>
            <DialogContent>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '20px',
                }}
              >
                <TabContext value={selectedOption}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList
                      onChange={handleTabChange}
                      aria-label="lab API tabs example"
                    >
                      <Tab label="Yeni Sorumlu Kişi Ekle" value="new" />
                      <Tab label="Mevcuttan Kişilerden Seç" value="existing" />
                      <Tab label="Kişi Seçmeden İlerle" value="proceed" />
                    </TabList>
                  </Box>
                </TabContext>
              </Box>

              {selectedOption === 'new' && (
                <>
                  <Grid xs={16} container alignItems="center" spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Sorumlu Kişi Ad*"
                        name="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        margin="normal"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Sorumlu Kişi Soyad*"
                        name="lastname"
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        margin="normal"
                      />
                    </Grid>
                  </Grid>

                  <Grid xs={16} container alignItems="center" spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Kullanıcı Adı*"
                        name="username"
                        value={userName}
                        onChange={(e) => setUserName(e.target.value)}
                        margin="normal"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        type={showPassword ? 'text' : 'password'}
                        label="Kullanıcı Şifresi*"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        margin="normal"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                                edge="end"
                              >
                                <Iconify
                                  icon={
                                    showPassword
                                      ? 'eva:eye-fill'
                                      : 'eva:eye-off-fill'
                                  }
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Grid xs={16} container alignItems="center" spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="E-Mail Adresi*"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        margin="normal"
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        label="Telefon*"
                        type="number"
                        name="phone"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        margin="normal"
                        onInput={(e) => {
                          let inputValue = e.target.value;
                          if (inputValue < 0) {
                            inputValue = '0';
                          }
                          // Eğer ilk karakter 0 ise ve giriş uzunluğu 1'den fazlaysa, ilk karakteri sil
                          if (inputValue.startsWith('0')) {
                            inputValue = inputValue.slice(1);
                          }
                          // Maksimum 10 karakter sınırlaması
                          if (inputValue.length > 10) {
                            inputValue = inputValue.slice(0, 10);
                          }
                          // Giriş değeri değiştiyse, yeni değeri güncelle
                          if (inputValue !== e.target.value) {
                            e.target.value = inputValue;
                            // State'i güncelle
                            setPhone(inputValue);
                          }
                        }}
                      />
                    </Grid>
                  </Grid>

                  <Grid xs={16} container alignItems="center" spacing={2}>
                    <Grid item xs={16}>
                      <div
                        style={{
                          height: '1px',
                          backgroundColor: '#EAECF0',
                          margin: '0 15px',
                          marginTop: '32px',
                        }}
                      ></div>
                    </Grid>
                  </Grid>
                </>
              )}
              {selectedOption === 'existing' && (
                <>
                  <Grid xs={16} container alignItems="center" spacing={2}>
                    <Grid item xs={16}>
                      <FormControl fullWidth margin="normal">
                        {userList.length === 0 ? (
                          <InputLabel>Kullanıcılar listeleniyor...</InputLabel>
                        ) : (
                          <InputLabel>Mevcutta Bulunan Kullanıcılar</InputLabel>
                        )}
                        <Select
                          disabled={userList.length === 0}
                          sx={{ width: '100%' }}
                          label="Mevcutta Bulunan Kullanıcılar"
                          value={selectedUser}
                          onChange={(e) => handleChangeSelectedUser(e)}
                          name="selectedUser"
                        >
                          {userList?.map((user, index) => (
                            <MenuItem key={index} value={user}>
                              {user.name} {user.lastname}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                  <Grid xs={16} container alignItems="center" spacing={2}>
                    <Grid item xs={16}>
                      <div
                        style={{
                          height: '1px',
                          backgroundColor: '#EAECF0',
                          margin: '0 15px',
                          marginTop: '32px',
                        }}
                      ></div>
                    </Grid>
                  </Grid>
                </>
              )}
            </DialogContent>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              mb={5}
            >
              <Button
                color="primary"
                onClick={backStep}
                variant="outlined"
                sx={{
                  marginTop: '32px',
                  width: '241px',
                  height: '46px',
                  marginRight: '25px',
                  fontSize: 12,
                  fontWeight: 500,
                }}
              >
                {language.commons.prev_step}
              </Button>
              <Button
                color="primary"
                onClick={handleSave}
                variant="contained"
                sx={{
                  marginTop: '32px',
                  width: '241px',
                  height: '46px',
                  backgroundColor: '#1570EF',
                  fontSize: 12,
                  fontWeight: 500,
                }}
                disabled={!allFieldsAreValid()}
              >
                {language.commons.complete}
              </Button>
            </Stack>
          </>
        )}
      </Dialog>

      <Dialog
        open={showResultMessage}
        onClose={handleCloseMessage}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {isEdit === true ? (
          <DialogTitle id="alert-dialog-title">
            {language.commons.store_update}
          </DialogTitle>
        ) : (
          <DialogTitle id="alert-dialog-title">
            {language.commons.store_add}
          </DialogTitle>
        )}
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {resultMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMessage}>{language.commons.okay}</Button>{' '}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddStoreModal;
